import VerticalMenu_VerticalMenuSolidColorSkinComponent from '../components/VerticalMenu/viewer/skinComps/VerticalMenuSolidColorSkin/VerticalMenuSolidColorSkin.skin';
import VerticalMenu_VerticalMenuSolidColorSkinController from '../components/VerticalMenu/viewer/VerticalMenu.controller';


const VerticalMenu_VerticalMenuSolidColorSkin = {
  component: VerticalMenu_VerticalMenuSolidColorSkinComponent,
  controller: VerticalMenu_VerticalMenuSolidColorSkinController
};


export const components = {
  ['VerticalMenu_VerticalMenuSolidColorSkin']: VerticalMenu_VerticalMenuSolidColorSkin
};

